// Layout
const dashboardLayout = () =>
  import('@/layouts/HospitalLayout/DashboardLayout/dashboardLayout.vue')

const support = () => import('./views/index')

// start Routes
export default [
  {
    path: '/hospital/support',
    component: dashboardLayout,
    children: [
      {
        path: '',
        name: 'hospitalSupport',
        meta: {
          name: 'hospitalSupport',
          parentName: 'marketplace',
          userType: '',
          permission: '',
          role: 'veterinary.clinic_owner'
        },
        component: support
      }
    ]
  }
]
